<template>
  <div>
<!--    <a-row class="top-area">-->
<!--      <a-col :span="6">-->
<!--        <chart-card :loading="loading" title="总销售额" total="￥126,560">-->
<!--          <a-tooltip title="指标说明" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <trend flag="up" style="margin-right: 16px;">-->
<!--              <span slot="term">周同比</span>-->
<!--              12%-->
<!--            </trend>-->
<!--            <trend flag="down">-->
<!--              <span slot="term">日同比</span>-->
<!--              11%-->
<!--            </trend>-->
<!--          </div>-->
<!--          <template slot="footer">日均销售额<span>￥ 234.56</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--      <a-col :span="6">-->
<!--        <chart-card :loading="loading" title="订单量" :total="8846 | NumberFormat">-->
<!--          <a-tooltip title="指标说明" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-area />-->
<!--          </div>-->
<!--          <template slot="footer">日订单量<span> {{ '1234' | NumberFormat }}</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--      <a-col :span="6">-->
<!--        <chart-card :loading="loading" title="支付笔数" :total="6560 | NumberFormat">-->
<!--          <a-tooltip title="指标说明" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-bar :height="40" />-->
<!--          </div>-->
<!--          <template slot="footer">转化率 <span>60%</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--      <a-col :span="6">-->
<!--        <chart-card :loading="loading" title="运营活动效果" total="78%">-->
<!--          <a-tooltip title="指标说明" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-progress color="rgb(19, 194, 194)" :target="80" :percentage="78" :height="8" />-->
<!--          </div>-->
<!--          <template slot="footer">-->
<!--            <trend flag="down" style="margin-right: 16px;">-->
<!--              <span slot="term">同周比</span>-->
<!--              12%-->
<!--            </trend>-->
<!--            <trend flag="up">-->
<!--              <span slot="term">日环比</span>-->
<!--              80%-->
<!--            </trend>-->
<!--          </template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--    </a-row>-->
    <a-row>
<!--      <a-col :span="8">-->
<!--        <a-card class="portlet trade-general">-->
<!--          <a-row>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本日营业额" suffix="元" :value="112893" :precision="2" />-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本日订单量" suffix="单" :value="112893"  />-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本月累计营业额" suffix="元" :value="112893" :precision="2" :value-style="{ color: '#3f8600' }">-->
<!--              </a-statistic>-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本月累计订单量" suffix="单" :value="112893"/>-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本年累计营业额" suffix="万元" :value="112893"/>-->
<!--            </a-col>-->
<!--            <a-col :span="8">-->
<!--              <a-statistic class="ststistic" title="本年累计订单量" suffix="万单" :value="112893"/>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-card>-->
<!--      </a-col>-->
      <a-col :span="12">
        <a-card class="portlet quickly-links" title="快速链接">
          <a-row>
            <a-col :span="6" v-for="item in linkItems">
              <a :href="item.address" target="_blank" class="link-item">
                <img :src="item.iconAdr" alt=""/>
                <span>{{ item.title }}</span>
              </a>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card class="portlet quickly-opers" title="快速操作">
            <a-col class="col-btn" :span="6" v-for="item in operItems">
              <a-button @click="onHandleClick(item)">{{ item.title }}</a-button>
            </a-col>
        </a-card>
      </a-col>
    </a-row>
    <a-row>
      <a-card title="工作日历">
        <a-calendar>
          <ul slot="dateCellRender" slot-scope="value" class="events calendar-cell-ul">
            <li v-for="item in getListData(value)" :key="item.content">
              <a-badge :status="item.type" :text="item.content" />
            </li>
          </ul>
        </a-calendar>
      </a-card>
    </a-row>

  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import ATooltip from "ant-design-vue/es/tooltip/Tooltip"
import MiniArea from '@/components/chart/MiniArea'
import MiniBar from '@/components/chart/MiniBar'
import MiniProgress from '@/components/chart/MiniProgress'
import RankList from '@/components/chart/RankList'
import Bar from '@/components/chart/Bar'
import LineChartMultid from '@/components/chart/LineChartMultid'
import { getAction } from '@/api/manage'
import Trend from '@/components/Trend'

export default {
  name: 'IndexFlowerRoll',
  components: {
    ATooltip,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    LineChartMultid,
  },
  created() {
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  mounted() {
    let queryParam = {
      pageNo: 1,
      pageSize: -1,
    };
    getAction(this.url.workPlanList, queryParam).then(res => {
      if (res.success && res.result) {
        this.workPlanItems = res.result.records;
      }
    });
  },
  data(){
    return {
      linkItems:[
        {address:'https://pan.baidu.com',iconAdr:require('../../assets/baidupan.svg'),title:'百度网盘'},
        {address:'https://account.ihr360.com',iconAdr:require('../../assets/ihr.png'),title:'i人事'},
        {address:'http://b.keruyun.com/',iconAdr:require('../../assets/baidupan.svg'),title:'客如云'},
        {address:'https://www.ovopark.com/login.html',iconAdr:require('../../assets/wandian.svg'),title:'万店掌'},
      ],
      operItems:[
        {title:"要货申请",url:"/erp/stock/requestIn"},
        {title:"库存调拨",url:"/erp/stock/Move"},
        {title:"库存盘点",url:"/erp/stock/Check"},
        {title:"实时库存",url:"/erp/stock/inventory"},
        {title:"其他出库",url:"/erp/stock/otherOut"},
        {title:"自产入库",url:"/erp/stock/SelfProdIn"},
        {title:"其他入库",url:"/erp/stock/otherIn"},
      ],
      loading: true,
      url: {
        workPlanList:"/work/workPlanCalendar/list"
      },
      workPlanItems: [],
    }
  },
  methods:{
    onHandleClick(item){
      this.$router.push({ path: item.url})
    },
    getListData(value) {
      let listData = [];
      let thisCellDate = value.format('YYYY-MM-DD');
      this.workPlanItems.forEach((item)=>{
        if(item.planDate === thisCellDate){
          listData.push({type:'success',content: item.planSummary});
        }
      });
      return listData;
    },
  }
}
</script>

<style lang="less" scoped>
  .calendar-cell-ul {
    list-style: none;
    text-align: right;
  }
  .top-area{
    div{
      padding-left:1px;
      padding-right: 1px;
    }
  }
  .portlet{
    min-height: 190px;
  }
  .quickly-opers{
    .col-btn {
      text-align: center;
      padding: 5px;
    }
  }
  .trade-general{
    .ststistic{
      float:left;
      margin-top: 10px;
      margin-left: 20px;
    }
  }
  .quickly-links {
    img{
      width:35px;
    }
    a.link-item>span{
      padding:2px;
      color:black;
      font-weight: 100;
    }
    a.link-item{
      display: block;
      line-height:50px;
      padding:5px;
      border-radius: 3px;
    }
    a.link-item:hover{
      background-color:#E6E6E6;
    }
  }
  .circle-cust{
    position: relative;
    top: 28px;
    left: -100%;
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  /* 首页访问量统计 */
  .head-info {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;

    &.center {
      text-align: center;
      padding: 0 32px;
    }

    span {
      color: rgba(0, 0, 0, .45);
      display: inline-block;
      font-size: .95rem;
      line-height: 42px;
      margin-bottom: 4px;
    }
    p {
      line-height: 42px;
      margin: 0;
      a {
        font-weight: 600;
        font-size: 1rem;
      }
    }
  }
</style>